import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, ImageBackground, StyleSheet, Text, View } from 'react-native';

import { FirstCup, SecondCup, ThirdCup } from '../../../../assets';

type RankCardProps = {
	backgroundImage: any;
	badge: any;
	gold: number;
	silver: number;
	bronze: number;
	total: number;
	color: string;
	cardWidth?: number;
};

const RankCard = ({
	backgroundImage,
	badge,
	gold,
	silver,
	bronze,
	total,
	color,
	cardWidth = 250,
}: RankCardProps) => {
	const { t } = useTranslation();

	return (
		<ImageBackground
			source={backgroundImage}
			style={[styles.card, { width: cardWidth }]}
			resizeMode='stretch'
		>
			<View style={styles.topBadge}>
				<Image source={badge} style={styles.badgeImage} resizeMode='contain' />
			</View>

			<View style={styles.trophies}>
				<View style={styles.trophyItem}>
					<Image source={FirstCup} style={styles.trophyIcon} />
					<Text style={styles.trophyCount}>{gold}</Text>
				</View>
				<View style={styles.trophyItem}>
					<Image source={SecondCup} style={styles.trophyIcon} />
					<Text style={styles.trophyCount}>{silver}</Text>
				</View>
				<View style={styles.trophyItem}>
					<Image source={ThirdCup} style={styles.trophyIcon} />
					<Text style={styles.trophyCount}>{bronze}</Text>
				</View>
			</View>

			<Text style={[styles.totalLabel, { color }]}>
				{t('T_SITE_TOURNAMENT_TOTAL')}: {total}
			</Text>
		</ImageBackground>
	);
};

const styles = StyleSheet.create({
	card: {
		height: 220,
		borderRadius: 16,
		padding: 16,
		justifyContent: 'space-between',
		alignItems: 'center',
		overflow: 'visible',
	},
	topBadge: {
		position: 'absolute',
		top: -60,
		alignSelf: 'center',
	},
	badgeImage: {
		width: 150,
		height: 150,
	},
	trophies: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '85%',
		marginTop: 60,
	},
	trophyItem: {
		alignItems: 'center',
		flex: 1,
	},
	trophyIcon: {
		width: 70,
		height: 70,
	},
	trophyCount: {
		color: '#fff',
		fontWeight: 'bold',
		marginTop: 4,
		fontSize: 16,
	},
	totalLabel: {
		marginTop: 10,
		fontSize: 18,
		fontWeight: 'bold',
		textAlign: 'center',
		marginVertical: 12,
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 2 },
		textShadowRadius: 3,
		letterSpacing: 1,
		textTransform: 'uppercase',
	},
	totalValue: {
		fontSize: 20,
		fontWeight: 'bold',
	},
});

export default RankCard;
